import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ComparisonType, Networks } from '@iotv/iotv-v3-types';
import { MenuItem, TextField, Toolbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
export const TypeByNetwork = props => {
    const { updateParams: setParamsInParent, lastQuery, lastQueryParamsRef, type, keyPress, index, attKey, children, selected, } = props;
    const getNetworkKeys = () => {
        let keys = Object.keys(Networks);
        return keys.sort((a, b) => {
            return a.localeCompare(b, undefined, {
                numeric: true,
                sensitivity: 'base',
            });
        });
    };
    const [params, setParams] = useState(lastQuery);
    const [options, _] = useState(getNetworkKeys());
    const updateParamsWithSelected = (value) => {
        console.log('WAH value', value);
        let inferred = Networks[value];
        console.log('WAH inferred', inferred);
        if (inferred) {
            const selectedParam = { type, attKey, value: inferred };
            lastQueryParamsRef.current = selectedParam;
            setParams(selectedParam);
        }
    };
    useEffect(() => {
        if (options.length > 0) {
            updateParamsWithSelected(options[0]);
        }
    }, [options]);
    useEffect(() => {
        if (params && selected) {
            setParamsInParent([{ key: attKey, value: params.value, predicate: ComparisonType.EQUALS }], index);
        }
        else {
            setParamsInParent(undefined, index);
        }
    }, [params, selected]);
    const handleParamChange = (e) => {
        let value = e.target.value;
        updateParamsWithSelected(value);
    };
    const displayNetworkTypes = (val) => {
        if (!val) {
            return '';
        }
        return `${val}`;
    };
    return (_jsxs(Toolbar, { children: [children, _jsx("div", { style: { flexGrow: 1 }, children: _jsx(TextField, { select: true, size: 'small', value: params?.value?.toLocaleUpperCase() || '', onChange: handleParamChange, onKeyDown: keyPress, slotProps: {
                        select: {
                            renderValue: () => _jsx(_Fragment, { children: displayNetworkTypes(params?.value) }),
                        },
                    }, children: options.map(types => (_jsx(MenuItem, { value: types, children: _jsx("b", { children: types }) }, types))) }) })] }));
};
